module.exports = __webpack_public_path__ + "static/media/rain-maker.f4b917f7.png";